import React from 'react';
import UniversalAddItemForm from '../../shared/UniversalAddItemForm';

const AddItemToAvoirAchatForm = ({ refAvoir, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_AVR_A"
      refValue={refAvoir}
      onSuccess={onSuccess}
      priceType="purchase"
      enableBatch={true}
      allowDuplicateArticles={true}
      useArticleList={false}
      extraFields={{ REMISEG: 0, MAJ_STK: false }}
      submitButtonText="Add all to Avoir Achat"
    />
  );
};

export default AddItemToAvoirAchatForm;
